document.addEventListener('DOMContentLoaded', () => {
    MegaMenu.init();
});

document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.shopify-section-header');
    
    function checkScroll() {
        if (window.scrollY > 20) {
            header.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
        }
    }
    checkScroll();
    window.addEventListener('scroll', checkScroll);
});

const MegaMenu = {
    init: function () {
        this.megaMenuSetup();
        if (window.innerWidth < 992) {
            this.megaMenuLinksMobile();
            this.openHamburgerMenu();
            this.openSearchModal();
        }
    },

    megaMenuSetup: function () {
        const linkSpec = document.querySelector('.js-site-header__link-spec');
        const megaMenu = document.querySelector('.js-site-header__megamenu');
        const megaMenuInner = document.querySelector('.js-site-header__megamenu-inner');
        const megaMenuMobBackBtn = document.querySelector('.js-site-header__megamenu-inner-left-mob-back');
        const body = document.body;

        if (linkSpec && megaMenu && megaMenuInner) {
            linkSpec.addEventListener('click', (event) => {
                event.stopPropagation();
                if(window.innerWidth < 992) {
                    window.location.href = "/collections/all";
                } else {
                    this.toggleMegaMenu(megaMenu, body);
                }
            });

            document.addEventListener('click', (event) => {
                if (!megaMenuInner.contains(event.target)) {
                    this.closeMegaMenu(megaMenu, body);
                }
            });

            if(window.innerWidth < 992) {
                if(megaMenuMobBackBtn) {
                    megaMenuMobBackBtn.addEventListener('click', () => {
                        megaMenu.classList.remove('is-active');
                    });
                }
            }


            megaMenuInner.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        }
    },

    toggleMegaMenu: function (megaMenu, body) {
        megaMenu.classList.toggle('is-active');
        body.classList.toggle('prevent-scroll', megaMenu.classList.contains('is-active'));
    },

    closeMegaMenu: function (megaMenu, body) {
        if (megaMenu.classList.contains('is-active')) {
            megaMenu.classList.remove('is-active');
            body.classList.remove('prevent-scroll');
            document.querySelector('.js-menu-btn').classList.remove('is-active');
        }
    },

    openHamburgerMenu: function() {
        const body = document.body;
        document.querySelector('.js-menu-btn').addEventListener('click', function() {
            document.querySelector('.site-header__links').classList.toggle('is-active');
            document.querySelector('.js-menu-btn').classList.toggle('is-active');
            body.classList.toggle('prevent-scroll');
        });
        document.addEventListener('click', function(event) {
            var isClickInsideLinksInner = document.querySelector('.site-header__links-inner').contains(event.target);
            var isClickOnButton = document.querySelector('.js-menu-btn').contains(event.target);

            if (!isClickInsideLinksInner && !isClickOnButton) {
                document.querySelector('.site-header__links').classList.remove('is-active');
                document.querySelector('.js-menu-btn').classList.remove('is-active');
                body.classList.remove('prevent-scroll');
            }
        });
    },

    megaMenuLinksMobile: function() {
        const titles = document.querySelectorAll('.site-header__megamenu-inner-left-links-title');
        titles.forEach(function(title) {
            title.addEventListener('click', function() {
                const parent = this.parentElement;
                parent.classList.toggle('active');
                const content = parent.querySelector('.site-header__megamenu-inner-left-links-holder');
                if (parent.classList.contains('active')) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    content.style.maxHeight = 0;
                }
            });
        });
    },

    openSearchModal: function() {
        const searchIcon = document.querySelector('.site-header__icon--search');
        const searchModal = document.querySelector('.search-modal__item');
        const searchInput = document.getElementById('Search-In-Modal');
    
        // Toggle is-visible class on search modal and focus on input
        searchIcon.addEventListener('click', function () {
            searchModal.classList.toggle('is-visible');
            if (searchModal.classList.contains('is-visible')) {
                setTimeout(() => {
                    searchInput.focus();
                }, 100);
            }
        });
    
        // Close search modal when clicking outside
        document.addEventListener('click', function (event) {
            if (!searchModal.contains(event.target) && !searchIcon.contains(event.target)) {
                searchModal.classList.remove('is-visible');
            }
        });
    
        // Prevent closing search modal when clicking inside
        searchModal.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    },
};